import { ReactNode, useState } from 'react';
import { SearchEngine } from '@coveo/headless';
import { buildRecommendationEngine } from '@coveo/headless/recommendation';

import { CoveoSearchInterfaceContext } from './CoveoSearchInterface.context';

interface CoveoSearchInterfaceProps {
  children: ReactNode;
  organizationId: string;
  baseUrl: string;
  accessToken: string;
  recommendationAccessToken: string;
  pipeline: string;
  searchHub: string;
  recommendationsPipeline: string;
  recommendationsHub: string;
  analyticsAccessToken?: string;
  analyticsEndpoint?: string;
}

export const CoveoSearchInterfaceProvider = ({
  children,
  organizationId,
  accessToken,
  recommendationAccessToken,
  baseUrl,
  pipeline,
  searchHub,
  recommendationsPipeline,
  recommendationsHub,
  analyticsAccessToken,
  analyticsEndpoint,
}: CoveoSearchInterfaceProps): React.JSX.Element => {
  const [isReady, setIsReady] = useState(false);
  const [engine, setEngine] = useState<SearchEngine>();
  const [recommendationEngine, setRecommendationEngine] =
    useState<ReturnType<typeof buildRecommendationEngine>>();
  const coveoSearchInterfaceContext = {
    isReady,
    setIsReady,
    organizationId,
    accessToken,
    recommendationAccessToken,
    baseUrl,
    pipeline,
    searchHub,
    recommendationsPipeline,
    recommendationsHub,
    analyticsAccessToken,
    analyticsEndpoint,
    setEngine,
    engine,
    recommendationEngine,
    setRecommendationEngine,
  };

  return (
    <CoveoSearchInterfaceContext.Provider value={coveoSearchInterfaceContext}>
      {children}
    </CoveoSearchInterfaceContext.Provider>
  );
};
